export const prod: boolean = import.meta.env.VITE_APP_ENV === 'prod';
export const test = import.meta.env.VITE_APP_ENV === 'test';

export const serverURL: string = import.meta.env.VITE_APP_API_BASE_URL;
export const landingPageURL: string = 'https://www.myaifrontdesk.com/';
export const whitelabelLandingPageURL = 'https://www.myaifrontdesk.com/white-label';
export const markoCalendlyURL = 'https://calendly.com/marko-aifrontdesk/strategy-call-with-marko';
